import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'durationTime'
})
export class DurationTimePipe implements PipeTransform {
    transform(minutes: number, format?: 'simple' | 'plural') {
        const isSimple = format === 'simple';
        const minutesInADay = 1440;
        let durationDays: number = undefined;
        let remainingMinutes = minutes;

        if (minutes >= minutesInADay) {
            durationDays = Math.floor(minutes / minutesInADay);
            remainingMinutes = minutes % minutesInADay;
        }
        const durationHours = Math.floor(remainingMinutes / 60);
        const durationMinutes = remainingMinutes % 60;

        let hourUnit = isSimple ? 'hrs' : 'hour';
        let minuteUnit = isSimple ? 'mins' : 'minute';
        const dayUnit = durationDays > 1 ? 'days' : 'day';

        if (durationHours < 2 && isSimple) {
            hourUnit = hourUnit.substring(0, hourUnit.length - 1);
        }

        if (format === 'plural') {
            minuteUnit = minuteUnit + 's';

            if (durationHours >= 2) {
                hourUnit = hourUnit + 's';
            }
        }

        const dayString = durationDays ? `${durationDays} ${dayUnit}` : undefined;
        const hourString = durationHours ? `${durationHours} ${hourUnit}` : undefined;
        const minuteString = durationMinutes ? `${durationMinutes} ${minuteUnit}` : undefined;

        // filter out undefined values and then join the strings
        const displayedTime = [dayString, hourString, minuteString].filter((val) => val).join(' ');
        return displayedTime;
    }
}
